import Slider from "react-slick";
import { Link } from "react-router-dom";
import "./heroSlider.css";
// REQUIRED FOR SLIDER TO WORK
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FlashDropSlider = ({ items }) => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: false,
        speed: 600,
        autoplaySpeed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <section className="flashdrop-slider">
            <Slider {...settings}>
                {items.map((item, index) => (
                    <div key={index}>
                        <div className="flashdrop-slide d-flex flex-column flex-md-row align-items-center justify-content-between p-4">

                            {/* LEFT SIDE */}
                            <div className="flashdrop-left">
                                <p className="flashdrop-hurry">
                                    Hurry only <span className="text-danger">{item.stock}%</span> phones left!
                                </p>

                                <h1 className="flashdrop-title">
                                    FLASH <br /> <span className="drop-text">DROP</span>
                                </h1>

                                <p className="flashdrop-date">{item.dropDate}</p>

                                <Link to={item.link} className="btn btn-primary flash-btn">
                                    Buy Now →
                                </Link>
                            </div>

                            {/* MIDDLE IMAGE */}
                            <div className="flashdrop-img">
                                <img src={item.img} alt={item.name} className="img-fluid" />
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="flashdrop-right text-end">
                                <h3 className="flashdrop-name">{item.name}</h3>

                                <p className="flashdrop-oldprice">
                                    Starting from <span className="text-decoration-line-through">{item.oldPrice}</span>
                                </p>

                                <h2 className="flashdrop-newprice">{item.newPrice}</h2>
                            </div>

                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default FlashDropSlider;
